<template>
  <v-row v-if="!isLoading">

    <v-col
      cols="12"
      sm="12"
      md="6"
    >
      <dashboard-card-total-earning :amount=totalAdminEarnings></dashboard-card-total-earning>
    </v-col>

    <v-col
      cols="12"
      md="6"
      sm="12"
    >
      <v-row class="match-height">
        <v-col
          cols="12"
          sm="6"
        >
          <statistics-card-vertical
            :change="totalFromSchools.change"
            :color="totalFromSchools.color"
            :icon="totalFromSchools.icon"
            :statistics="totalFromSchools.amount"
            :stat-title="totalFromSchools.statTitle"
            :subtitle="totalFromSchools.subtitle"
          ></statistics-card-vertical>
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <statistics-card-vertical
            :change="totalFromParents.change"
            :color="totalFromParents.color"
            :icon="totalFromParents.icon"
            :statistics="totalFromParents.amount"
            :stat-title="totalFromParents.statTitle"
            :subtitle="totalFromParents.subtitle"
          ></statistics-card-vertical>
        </v-col>
      </v-row>
    </v-col>

    <v-col
      cols="12"
      md="12"
    >
      <dashboard-statistics-card :all-counts=allCounts></dashboard-statistics-card>
    </v-col>



    <v-col
      cols="12"
      sm="12"
      md="6"
    >
      <dashboard-weekly-overview
      :trip-count=plannedTripsCount
      :trip-dates=plannedTripsDates
      ></dashboard-weekly-overview>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <dashboard-card-plans
      :best-plans=bestSalesPlans
      ></dashboard-card-plans>
    </v-col>

  </v-row>
  <v-row v-else>
    <v-col
      cols="12"
      sm="6"
      md="6"
    >
      <v-skeleton-loader
        type="card"
        height="200"
      ></v-skeleton-loader>
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <v-row class="match-height">
        <v-col
          cols="12"
          sm="6"
        >
          <v-skeleton-loader
            type="card"
            height="200"
          ></v-skeleton-loader>
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-skeleton-loader
            type="card"
            height="200"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-col>

    <v-col
      cols="12"
      md="12"
    >
      <v-skeleton-loader
        type="card"
        height="120"
      ></v-skeleton-loader>
    </v-col>

    <v-col
      cols="12"
      sm="6"
      md="6"
    >
      <v-skeleton-loader
        type="image"
        height="500"
      ></v-skeleton-loader>
    </v-col>

    <v-col
      cols="12"
      md="6"
    >
      <v-skeleton-loader
        type="image"
        height="500"
      ></v-skeleton-loader>
    </v-col>

  </v-row>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiPoll, mdiCurrencyUsd, mdiCloseOctagonOutline, mdiCard, mdiSchool, mdiAlien, mdiAccountAlert, mdiAccountBox, mdiAccountCash } from '@mdi/js'
import StatisticsCardVertical from '@/components/statistics-card/StatisticsCardVertical.vue'
import auth from '@/services/AuthService'
import * as API from '@/services/API'
// demos
import DashboardStatisticsCard from './DashboardStatisticsCard.vue'
import DashboardCardTotalEarning from './DashboardCardTotalEarning.vue'
import DashboardCardPlans from './DashboardCardPlans.vue'
import DashboardWeeklyOverview from './DashboardWeeklyOverview.vue'

export default {
  components: {
    StatisticsCardVertical,
    DashboardStatisticsCard,
    DashboardCardTotalEarning,
    DashboardCardPlans,
    DashboardWeeklyOverview,
  },
  data() {
    return {
      isLoading: false,
      totalFromSchools: {
        statTitle: 'Schools Payments',
        icon: mdiSchool,
        color: 'success',
        amount: '',
      },
      bestSalesPlans: [],
      plannedTripsCount: [],
      plannedTripsDates: [],
      bestSalesPlansColors: [
        'success', 'error', 'warning', 'secondary', 'error',
      ],
      totalFromParents: {
        statTitle: 'Parents Payments',
        icon: mdiAccountCash,
        color: 'info',
        amount: '',
      },
      totalAdminEarnings: null,
      allCounts:
      [
        {
          title: 'Schools',
          total: '',
        },
        {
          title: 'Guardians',
          total: '',
        },
        {
          title: 'Drivers',
          total: '',
        },
        {
          title: 'Students',
          total: '',
        },
        {
          title: 'Routes',
          total: '',
        },
        {
          title: 'Stops',
          total: '',
        },
      ],
    }
  },
  mounted() {
    this.fetchDashboardStatistics()
  },
  methods: {
    fetchDashboardStatistics() {
      this.isLoading = true;
      this.reservations = [];

      const handleDashboardResponse = (response) => {
        if (!response || !response.data) {
          this.setDefaultDashboardValues();
          return;
        }
        
        // Safely set the data with fallbacks
        this.totalFromSchools.amount = response.data.paidSchools || '0';
        this.totalFromParents.amount = response.data.paidParents || '0';
        this.totalAdminEarnings = response.data.totalPaid || '0';
        
        // Safely set counts with fallbacks
        if (response.data.totalSchools !== undefined) this.allCounts[0].total = response.data.totalSchools;
        if (response.data.totalGuardians !== undefined) this.allCounts[1].total = response.data.totalGuardians;
        if (response.data.totalDrivers !== undefined) this.allCounts[2].total = response.data.totalDrivers;
        if (response.data.totalStudents !== undefined) this.allCounts[3].total = response.data.totalStudents;
        if (response.data.totalRoutes !== undefined) this.allCounts[4].total = response.data.totalRoutes;
        if (response.data.totalStops !== undefined) this.allCounts[5].total = response.data.totalStops;
        
        // Safely handle bestSalesPlans
        if (response.data.bestSalesPlans && Array.isArray(response.data.bestSalesPlans)) {
          this.bestSalesPlans = response.data.bestSalesPlans;
          this.bestSalesPlans.forEach((item, index) => {
            item.color = this.bestSalesPlansColors[index % this.bestSalesPlansColors.length];
          });
        } else {
          this.bestSalesPlans = [];
        }
        
        // Safely handle plannedTrips
        this.plannedTripsCount = [];
        this.plannedTripsDates = [];
        if (response.data.plannedTrips && typeof response.data.plannedTrips === 'object') {
          for (var key in response.data.plannedTrips) {
            this.plannedTripsCount.push(response.data.plannedTrips[key]);
            this.plannedTripsDates.push(key);
          }
        }
      };

      API.apiClient
        .get('/admin-dashboard/all')
        .then((response) => {
          handleDashboardResponse(response);
        })
        .catch((error) => {
          console.error('Dashboard API Error:', error);
          this.setDefaultDashboardValues();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleDashboardError(message) {
      this.$notify({
        title: "Dashboard Error",
        text: message,
        type: "error",
      });
      
      // Don't redirect for admin users, just show the error
      console.log('Dashboard error handled:', message);
    },
    
    setDefaultDashboardValues() {
      // Set default values for temporary admin mode
      this.totalFromSchools.amount = '0';
      this.totalFromParents.amount = '0';
      this.totalAdminEarnings = '0';
      this.bestSalesPlans = [];
      this.plannedTripsCount = [];
      this.plannedTripsDates = [];
      
      // Set default counts
      this.allCounts.forEach(count => {
        count.total = '0';
      });
    }
  },
}
</script>

<style lang="scss">
.v-skeleton-loader__image {
    height: 400px !important;
}
</style>
